import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { toast } from "react-hot-toast";
import OrganisationLayout from "../layout/OrganisationLayout";
import { UpdatePasswordAction } from "../../Redux/Action/PasswordAction";
import { ForgotvalidateSchema } from "../../Util/formValidations";

export default function OrganisationGroupsUpdatePassword() {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      oldpassword: "",
      newpassword: "",
      confirmedpassword: "",
    },
    validationSchema: ForgotvalidateSchema,
    onSubmit: async (values) => {
      const modifyData = {
        oldPassword: values?.oldpassword,
        newPassword: values?.newpassword,
      };
      const response = await dispatch(UpdatePasswordAction(modifyData));

      if (response?.payload?.statusCode === 200) {
        formik.resetForm();
        toast.success("Password Updated Successfully ", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(response?.payload?.message);
      }
    },
  });

  return (
    <OrganisationLayout>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xxl={5} xl={5} lg={6} className="mt-4">
            <div className="cmn-card-color mt-5 pb-4 pt-4">
              <div className="back-page-title">
                <Link to="/organisations/settings">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M13.75 5.5L8.25 11L13.75 16.5"
                      stroke="#CCD2E3"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
              <div className="student-view">
                <h2>Update Password</h2>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Old Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Type Here"
                      name="oldpassword"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.oldpassword}
                    />
                    {formik.submitCount > 0 && formik.errors.oldpassword && (
                      <div className="error text-danger">{formik.errors.oldpassword}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Type Here"
                      name="newpassword"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.newpassword}
                    />
                    {formik.submitCount > 0 && formik.errors.newpassword && (
                      <div className="error text-danger">{formik.errors.newpassword}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Re Type New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Type Here"
                      name="confirmedpassword"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.confirmedpassword}
                    />
                    {formik.submitCount > 0 && formik.errors.confirmedpassword && (
                      <div className="error text-danger">
                        {formik.errors.confirmedpassword}
                      </div>
                    )}
                  </Form.Group>

                  <button type="submit" className="cmn-pink w-50 mb-3 mt-4">
                    Update Password
                  </button>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
